import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import ts1 from "../../images/testimonial.png";

const settings = {
  dots: true,
  arrows: false,
  speed: 1000,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
};

const Testimonial = () => {
  const [testimonialData, setTestimonialData] = useState([]);
  useEffect(() => {
    const getTestimonialData = async () => {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/customer-feedbacks`
      );
      const data = await response.json();
      setTestimonialData(data.data);
    };
    getTestimonialData();
  }, []);

  return (
    <section className="wpo-testimonials-section section-padding">
      <div className="container">
        <div className="row align-items-center justify-content-center">
          <div className="col-lg-5" style={{ width: "100%" }}>
            <div>
              <h2
                style={{
                  width: "100%",
                  textAlign: "center",
                  fontSize: "3rem",
                  fontWeight: "bold",
                }}
              >
                Hear From Our Clients
              </h2>
              <p>
                {" "}
                Our clients’ satisfaction is our top priority. See what they
                have to say about their experiences with Elite Spark’s
                professional cleaning team—homes and offices transformed with
                care, precision, and attention to detail.
              </p>
            </div>
          </div>
        </div>
        <div className="wpo-testimonials-wrap">
          <div className="row align-items-center">
            <div className="col-lg-5 col-12">
              <div className="wpo-testimonials-img">
                <img src={ts1} alt="" className="img-fluid" />
              </div>
            </div>
            <div className="col-lg-7 col-12">
              <div className="wpo-testimonials-text">
                <div className="quote">
                  <i className="fa fa-quote-left" aria-hidden="true"></i>
                </div>
                <div className="wpo-testimonials-slide owl-carousel">
                  <Slider {...settings}>
                    {testimonialData?.length > 0 ? (
                      testimonialData?.map((tesmnl, tsm) => (
                        <div className="wpo-testimonials-slide-item" key={tsm}>
                          <p>{tesmnl?.message}</p>
                          <h5>{tesmnl?.fullName}</h5>
                          <span>{tesmnl?.role}</span>
                        </div>
                      ))
                    ) : (
                      <div
                        className="p-4 text-center "
                        style={{
                          fontSize: "2rem",
                          fontWeight: "bold",
                        }}
                      >
                        No Testimonials Found
                      </div>
                    )}
                  </Slider>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonial;
